


import SlicerJumbo from '@/components/common/slicer-jumbo/SlicerJumbo.vue'
import OurOffer from '@/components/home/our-offer/OurOffer.vue'
import Quality from '@/components/home/quality/Quality.vue'
import WhyUs from '@/components/home/why-us/WhyUs.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    SlicerJumbo,
    OurOffer,
    WhyUs,
    Quality
  }
})
export default class Home extends Vue {

}
